import { render, staticRenderFns } from "./OnboardingMatchingPersonalityPage.vue?vue&type=template&id=50fa0711&scoped=true&"
import script from "./OnboardingMatchingPersonalityPage.vue?vue&type=script&lang=ts&"
export * from "./OnboardingMatchingPersonalityPage.vue?vue&type=script&lang=ts&"
import style0 from "./OnboardingMatchingPersonalityPage.vue?vue&type=style&index=0&id=50fa0711&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50fa0711",
  null
  
)

export default component.exports